/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button } from "@flick/fep-library";
import { LoadingSection } from "components/LoadingSection";
import { format } from "date-fns";
import { Item } from "elements/Item";
import { useGetInvoiceQuery } from "queries/billingApi";
import { expireTime } from "queries/queries.utils";
import React from "react";
import { invoicePaymentStatus } from "utils/invoicePaymentStatus";
import { jwtClient } from "utils/jwtClient";

type OutstandingBillListItemProps = {
  invoice: OutstandingInvoiceSummary;
};

export const OutstandingBillListItem: React.FC<
  OutstandingBillListItemProps
> = ({ invoice }) => {
  const { number: invoiceNumber, due_at, total, balance } = invoice.attributes;
  const { data: billData, isFetching: isBillFetching } = useGetInvoiceQuery(
    { invoiceNumber, jwtClient },
    {
      skip: !invoiceNumber || isNaN(Number(invoiceNumber)),
      refetchOnMountOrArgChange: expireTime,
    },
  );

  const bill = billData?.bill;
  const paymentStatusDetails = invoicePaymentStatus(invoice);

  if (isBillFetching) {
    return <LoadingSection />;
  }

  const periodStart = bill?.billing_period
    ? new Date(bill.billing_period.period_started_at)
    : undefined;

  const periodEnd = bill?.billing_period
    ? new Date(bill.billing_period.period_ended_at)
    : undefined;

  const itemLabel =
    periodStart && periodEnd
      ? `${format(periodStart, "d MMMM")} — ${format(periodEnd, "d MMMM")}`
      : `Invoice Number: ${invoiceNumber}`;

  return (
    <>
      <Item
        href={`/bills/${invoiceNumber}`}
        label={itemLabel}
        labelNote={`${paymentStatusDetails.verb} ${format(new Date(due_at), "EEE d MMM")}`}
        value={balance}
        valueNote={
          balance !== total ? "Remaining" : paymentStatusDetails.status
        }
        statusDetails={paymentStatusDetails}
      />
      {/* @TODO: hidden for now, this work needs to be planned so it will work with windcave on mobile */}
      {/* {paymentStatusDetails.type === "alert" && (
        <Button
          extraClasses="button--expanded"
          onClick={(event) => {
            event.preventDefault();
            // onHandlePayNowClick();
          }}
        >
          Pay now
        </Button>
      )} */}
    </>
  );
};
